import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { StartPage } from "@/features/onboarding/pages/start-page";

export const Route = createFileRoute("/onboarding/start")({
	head: () => pageTitle("Sign up"),
	component: StartPage,
});
